import { render, staticRenderFns } from "./ShowSeats.vue?vue&type=template&id=1b8ea496&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ShowSeats.vue?vue&type=script&lang=js&"
export * from "./ShowSeats.vue?vue&type=script&lang=js&"
import style0 from "./ShowSeats.vue?vue&type=style&index=0&id=1b8ea496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ea496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
